import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { apiClient } from "@/services/api-client";
import { lettersBeforeNumbers } from "@/utils/sort";
/**
 * Lists the workspace's templates, sorted by name. Defaults to `letter` so patient
 * letter pickers never receive SMS landing pages; pass `"all"` to list every type.
 */
export function fetchLetterTemplates(_x) {
  return _fetchLetterTemplates.apply(this, arguments);
}

/** Fetches a single template's body HTML. */
function _fetchLetterTemplates() {
  _fetchLetterTemplates = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(workspaceId) {
    var includeTemplate,
      type,
      typeParam,
      _yield$apiClient$get,
      data,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          includeTemplate = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
          type = _args.length > 2 && _args[2] !== undefined ? _args[2] : "letter";
          typeParam = type === "all" ? "" : "&type=".concat(type);
          _context.n = 1;
          return apiClient.get("/workspaces/".concat(workspaceId, "/letter/template/list/?include_template=").concat(includeTemplate).concat(typeParam));
        case 1:
          _yield$apiClient$get = _context.v;
          data = _yield$apiClient$get.data;
          if (Array.isArray(data)) {
            _context.n = 2;
            break;
          }
          return _context.a(2, []);
        case 2:
          return _context.a(2, _toConsumableArray(data).sort(function (a, b) {
            var _a$name, _b$name;
            return lettersBeforeNumbers((_a$name = a.name) !== null && _a$name !== void 0 ? _a$name : "", (_b$name = b.name) !== null && _b$name !== void 0 ? _b$name : "");
          }));
      }
    }, _callee);
  }));
  return _fetchLetterTemplates.apply(this, arguments);
}
export function fetchLetterTemplateBody(_x2, _x3) {
  return _fetchLetterTemplateBody.apply(this, arguments);
}

/** Creates a template (letter by default; pass `type` for SMS landing pages). */
function _fetchLetterTemplateBody() {
  _fetchLetterTemplateBody = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(workspaceId, templateId) {
    var _yield$apiClient$get2, data;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return apiClient.get("/workspaces/".concat(workspaceId, "/letter/template/").concat(templateId, "/body/"));
        case 1:
          _yield$apiClient$get2 = _context2.v;
          data = _yield$apiClient$get2.data;
          return _context2.a(2, data);
      }
    }, _callee2);
  }));
  return _fetchLetterTemplateBody.apply(this, arguments);
}
export function createLetterTemplate(_x4, _x5, _x6, _x7) {
  return _createLetterTemplate.apply(this, arguments);
}

/** Updates a template's name, body and optional type. */
function _createLetterTemplate() {
  _createLetterTemplate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(workspaceId, name, template, type) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return apiClient.post("/workspaces/".concat(workspaceId, "/letter/template/create/"), _objectSpread({
            name: name,
            template: template
          }, type ? {
            type: type
          } : {}));
        case 1:
          return _context3.a(2);
      }
    }, _callee3);
  }));
  return _createLetterTemplate.apply(this, arguments);
}
export function updateLetterTemplate(_x8, _x9, _x0, _x1, _x10) {
  return _updateLetterTemplate.apply(this, arguments);
}
function _updateLetterTemplate() {
  _updateLetterTemplate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(workspaceId, templateId, name, template, type) {
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return apiClient.post("/workspaces/".concat(workspaceId, "/letter/template/").concat(templateId, "/update/"), _objectSpread({
            name: name,
            template: template
          }, type ? {
            type: type
          } : {}));
        case 1:
          return _context4.a(2);
      }
    }, _callee4);
  }));
  return _updateLetterTemplate.apply(this, arguments);
}